import type { ReactNode } from 'react';

import styles from './sidebar-menu.module.css';

/** @public */
export interface SidebarMenuProps {
  /** The items and sections of one menu block, such as primary or utility. */
  children?: ReactNode;
}

/**
 * Vertical list of sidebar items and sections, 4 apart.
 *
 * @remarks
 * It has no margin, padding, width or scrolling of its own: the slot that
 * hosts it decides where it sits. On mobile it is the same column, inside
 * core's menu overlay.
 *
 * @public
 */
export const SidebarMenu = ({ children }: SidebarMenuProps) => (
  <div className={styles.menu}>{children}</div>
);
